export default "__VITE_ASSET__7cPkJ2AG__"